<template>
	<section>
		<div>
			<tabs-component
				v-if="$route.name === 'main-dashboard'"
			    :tabs="tabs">
			</tabs-component>
			<v-layout row wrap>
				<v-flex md6 pt-0>
					<v-layout row wrap>
						<v-flex md4 pt-0>
							<v-select
								class="filter-select"
								v-bind:items="subsidiaries"
								item-text="name"
								item-value="id"
								v-model="subsidiaryId"
								hide-details
								label="Sucursal"
								v-on:change="loadBuildings"
								single-line
								bottom>
							</v-select>
						</v-flex>
						<v-flex md4 pt-0>
							<v-select
								class="filter-select"
								v-bind:items="buildings"
								v-model="buildingId"
								v-bind:disabled="buildings.length === 0"
								item-text="name"
								item-value="id"
								hide-details
								v-on:change="loadRooms"
								label="Edificio"
								single-line
								bottom>
							</v-select>
						</v-flex>
						<v-flex md4 pt-0>
							<v-select
								class="filter-select"
								v-bind:items="rooms"
								item-text="name"
								item-value="id"
								v-bind:disabled="rooms.length === 0"
								v-model="roomId"
								hide-details
								v-on:change="filterById"
								label="Todas las habitaciones"
								single-line
								bottom>
							</v-select>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
			<v-layout row wrap body-border-bottom>
				<v-flex md4 my-1>
					<v-layout row wrap class="calendar-range">
						<v-flex md6 pa-0>
							<v-menu
								lazy
								v-model="menu"
								transition="scale-transition"
								offset-y
								full-width
								class="menu-date-picker"
								:nudge-left="40"
								max-width="290px"
								v-on:input="changeIcon">
								<v-text-field
									slot="activator"
									label="Picker in menu"
									v-model="startDate"
									prepend-icon="event"
									:append-icon="arrowIconStart"
									:append-icon-cb="toggleIconStartDate"
									single-line
									hide-details
									readonly
								></v-text-field>
								<v-date-picker
									v-model="startDate"
									v-on:input="onDateFilter"
									locale="es-PE"
									:date-format="changeFormatDate"
									:formatted-value="formatted"
									no-title
									scrollable>
								</v-date-picker>
							</v-menu>
						</v-flex>
						<v-flex md6 pa-0>
							<v-menu
								lazy
								v-model="menuEnd"
								transition="scale-transition"
								offset-y
								full-width
								class="menu-date-picker"
								:nudge-left="40"
								max-width="290px"
								v-on:input="changeEndIcon">
								<v-text-field
									slot="activator"
									label="Picker in menu"
									v-model="endDate"
									:append-icon="arrowIconEnd"
									:append-icon-cb="toggleIconEndDate"
									single-line
									hide-details
									readonly
								></v-text-field>
								<v-date-picker
									v-model="endDate"
									v-on:input="onDateFilter"
									locale="es-PE"
									:date-format="changeFormatDate"
									:formatted-value="formatted"
									no-title
									scrollable>
								</v-date-picker>
							</v-menu>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex md8 my-1 text-xs-right>
					<filters-by-time
						:loading="loading"
						:value="value"
						v-on:apply-filter="onDateFilter"></filters-by-time>
				</v-flex>
			</v-layout>
			<v-layout row class="divider-rows">
				<v-flex md6 pt-2 class="divider1">
					<v-layout row wrap align-items-center>
						<v-flex md2>
							<h5 class="little-subtitle-default mb-0 mr-3">Habitaciones</h5>
						</v-flex>
						<v-flex md3>
							<v-select
								class="oval-select mr-2"
								v-bind:items="roomCleaningTypes"
								item-text="name"
								item-value="id"
								v-model="roomTypeId"
								label="Tipo de limpieza"
								single-line
								v-on:change="filterType"
								hide-details
								bottom>
							</v-select>
						</v-flex>
						<v-flex md3>
							<v-select
								class="oval-select"
								v-bind:items="statusTypes"
								item-text="name"
								item-value="id"
								v-model="statusTypeId"
								label="Tipo de estado"
								single-line
								v-on:change="filterStatusType"
								hide-details
								bottom>
							</v-select>
						</v-flex>
						<v-flex md4 text-xs-right>
							<button
								type="button"
								class="oval-button cancel"
								v-on:click="cancelEdit"
								v-if="roomsSelected.length > 0">
								Cancelar
							</button>
							<button
								type="button"
								class="oval-button ml-2"
								v-on:click.stop="dialog = true"
								:disabled="roomsSelected.length === 0">
								Editar
							</button>
						</v-flex>
					</v-layout>
					<v-layout
						row
						wrap
						class="text-xs-left"
						v-for="state in states"
					    :key="state.id">
						<v-flex md12>
							<div class="label-status">
								<h5>
									<router-link :to="`/dashboard/state/1/${state.name}`">{{ state.name }}</router-link>
								</h5>
								<h5>{{ state.rooms.length }} habitaciones</h5>
							</div>
						</v-flex>
						<v-flex md12>
							<room-status
								v-for="room in state.rooms"
							    :key="room.id"
								v-bind:background-color="room.color_state"
								v-bind:clean-state="room.clean_state"
							    v-bind:number="room.number"
								v-bind:code="room.code_roomtype"
								v-bind:status-icon-img="room.icon_url"
								:room="room"
								:label-for="`room-${room.id}`"
								:extra-state="room.extra_state"
								:show-circle="true"
							    v-bind:name="room.name"
								v-on:on-room-selected="roomIsSelected">
							</room-status>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex md6 class="divider2">
					<v-layout row wrap pl-1>
						<h5 class="little-subtitle-default">Estados</h5>
					</v-layout>
					<v-layout row wrap pl-1 class="summary-container">
						<div v-for="summaryState in summaryStates"
							 :key="summaryState.id">
							<div class="summary" :style="`border-color: ${summaryState.color_state}; color: ${summaryState.color_state};`">
								<p>{{ summaryState.quantity }}</p>
							</div>
							<router-link :to="{ name: 'housemaids-by-state', params: { stateId: summaryState.id, stateName: summaryState.name_state } }">
								{{ summaryState.name_state }}
							</router-link>
						</div>
					</v-layout>
					<v-layout row wrap pl-1>
						<h5 class="little-subtitle-default">Mucamas</h5>
					</v-layout>
					<v-layout row wrap pl-1>
						<div class="label-status mb-1">
							<h5>Nombre</h5>
							<h5>Habitación</h5>
							<h5>Calificación</h5>
						</div>
					</v-layout>
					<v-layout row wrap class="report-maid pl-0 ml-1" v-for="maid in housemaids"
					    :key="maid.id">
						<v-flex md4 text-xs-left>
							<router-link :to="{ name: 'housemaids-profile', params: { id: maid.id } }">{{ maid.name }} {{ maid.lastname }}</router-link>
						</v-flex>
						<v-flex md4>
							<div class="score-ball" :style="`background-color: ${maid.color_state}`"></div>
						</v-flex>
						<v-flex md4 text-xs-right>
							<span>{{ maid.room_assigned }}</span>
						</v-flex>
					</v-layout>
					<v-layout row wrap class="alerts pl-1">
						<h5 class="little-subtitle-default">Alertas</h5>
					</v-layout>
					<v-layout row wrap pl-1 class="summary-container">
						<div v-for="summaryAlert in summaryAlerts"
							 :key="summaryAlert.id">
							<div class="summary" :style="`border-color: ${summaryAlert.color_alert}; color: ${summaryAlert.color_alert};`">
								<p>{{ summaryAlert.quantity }}</p>
							</div>
							<router-link :to="{ name: summaryAlert.routerName }">{{ summaryAlert.name_alert }}</router-link>
						</div>
					</v-layout>
					<v-layout row wrap pl-1>
						<h5 class="little-subtitle-default">Actividades - Real time</h5>
					</v-layout>
					<v-layout row>
						<div class="realtime-content">
							<v-layout row class="realtime-item">
								<v-flex md1>
									<img src="https://randomuser.me/api/portraits/women/59.jpg"
									    alt="">
								</v-flex>
								<v-flex md11 pl-4>
									<v-layout row wrap>
										<h5>
											Maria Chiappe
											<span class="realtime-gray">cambió de estado</span>
											<span class="realtime-blue">En curso</span>
											<span class="realtime-gray">a</span>
											<span class="realtime-blue">Almuerzo</span>
										</h5>
									</v-layout>
									<v-layout row class="little-icon">
										<v-flex md6>
											<div class="rt-calendar red"></div>
											<h6 class="mb-0">
												<span class="realtime-gray">Fecha:</span> 24/03/2017
											</h6>
										</v-flex>
										<v-flex md6>
											<div class="rt-calendar blue"></div>
											<h6 class="mb-0">
												<span class="realtime-gray">Hora:</span> 09:15:24 am
											</h6>
										</v-flex>
									</v-layout>
								</v-flex>
							</v-layout>
						</div>
					</v-layout>
				</v-flex>
			</v-layout>
		</div>
		<v-dialog v-model="dialog" width="685" content-class="modal-dashboard">
			<v-card>
				<v-card-title class="headline">
					Cambiar de estado
					<v-icon v-on:click.stop="dialog = false">cancel</v-icon>
				</v-card-title>
				<v-card-text>
					<v-layout row wrap text-xs-left>
						<v-flex md12>
							<p class="subtitle">Habitaciones seleccionadas</p>
						</v-flex>
						<v-flex md12 mt-2>
							<room-status
								v-for="roomSelected in roomsSelected"
							    :key="roomSelected.id"
								v-bind:background-color="roomSelected.color_state"
								v-bind:clean-state="roomSelected.clean_state"
							    v-bind:number="roomSelected.number"
								v-bind:code="roomSelected.code_roomtype"
								v-bind:status-icon-img="roomSelected.icon_url"
								v-bind:room="roomSelected"
								v-bind:label-for="`room-selected-${roomSelected.id}`"
								v-bind:extra-state="roomSelected.extra_state"
								v-bind:show-circle="true"
							    v-bind:name="roomSelected.name"
								v-bind:is-added="roomSelected.isAdded"
								v-bind:room-id="roomSelected.id"
								v-bind:state-code="roomSelected.code_state"
								v-on:on-room-removed="deleteRoomAdded">
							</room-status>
						</v-flex>
						<v-flex md12>
							<p class="subtitle">Define el estado de las habitaciones</p>
						</v-flex>
						<v-flex md12 mt-2>
							<room-status
								v-for="roomState in statusTypes"
								:key="roomState.id"
								v-if="roomState.id"
								v-bind:background-color="roomState.color_state"
								v-bind:status-icon-img="roomState.icon_url"
								v-bind:name="roomState.code_state"
								v-bind:room="roomState"
								v-bind:label-for="`room-state-${roomState.id}`"
								v-bind:name-state="roomState.name"
								v-on:on-room-selected="stateToChange">
							</room-status>
						</v-flex>
					</v-layout>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						class="btn-save mr-3 mb-2"
						v-on:click="editRoomStates"
						:loading="loading"
						:disabled="loading">
						Guardar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</section>
</template>

<script>
import mixin from '@/shared/mixins';
import FiltersByTime from '@/components/shared/FiltersByTime';
import TabsComponent from '@/components/shared/TabsComponent';
import RoomStatus from '@/components/shared/RoomStatus';

const date = new Date();

const currentDate = {
	day: date.getDate(),
	month: date.getMonth() < 9 ? `0${date.getMonth()}` : date.getMonth() + 1,
	today: date.toISOString().substr(0, 10),
	value: date,
	year: date.getFullYear(),
};

function created() {
	this.loadData();
	this.loadSubsidiaries();
	this.isMounted = true;
}

function cancelEdit() {
	this.roomsSelected.forEach((roomSelected) => {
		this.states[roomSelected.code_state].rooms =
		this.states[roomSelected.code_state].rooms.map((room) => {
			const newRoom = Object.assign({}, room);
			if (roomSelected.id === room.id) {
				newRoom.isAdded = false;
				newRoom.isSelected = false;
			}
			return newRoom;
		});
	}, this);
	this.roomsSelected = [];
}

function changeIcon(result) {
	this.onChange = result;
}

function changeEndIcon(result) {
	this.onChangeEnd = result;
}

function changeFormatDate(value) {
	return new Date(value).toISOString().substr(0, 10);
}

function deleteRoomAdded(id) {
	const index = this.roomsSelected.findIndex(roomSelected => roomSelected.id === id);
	this.roomsSelected.forEach((roomSelected) => {
		this.states[roomSelected.code_state].rooms =
		this.states[roomSelected.code_state].rooms.map((room) => {
			const newRoom = Object.assign({}, room);
			if (room.id === id) {
				newRoom.isAdded = false;
				newRoom.isSelected = false;
			}
			return newRoom;
		});
	}, this);
	if (index || index === 0) {
		this.roomsSelected.splice(index, 1);
	}
}

async function editRoomStates() {
	const newRoomsSelected = this.roomsSelected.map((room) => {
		const newRoom = Object.assign({}, room);
		newRoom.hk_ms_statehk_room_id = this.stateSelectedId;
		return newRoom;
	}, this);
	await this.$http.post('room-update-multiple', newRoomsSelected);
	this.showNotification('Los cambios fueron guardados satisfactoriamente', 'success');
	this.dialog = false;
	this.loadData();
	this.roomsSelected = [];
	this.stateSelected = null;
	this.stateSelectedId = null;
	this.statusTypes = this.statusTypes.map((status) => {
		const newStatus = Object.assign({}, status);
		newStatus.isSelected = false;
		newStatus.isAdded = false;
		return newStatus;
	});
}

function filterById(id) {
	this.filterByRoomId = this.renderFilter('hot_ms_roomtype_id', id, 'eq');
	this.loadData();
}

function filterType(id) {
	if (id) {
		this.filterByTypeId = this.renderFilter('com_ms_type_cleaning_id', id, 'eq');
	} else {
		this.filterByTypeId = null;
		this.roomTypeId = 0;
	}
	this.loadData();
}

function filterStatusType(id) {
	if (id) {
		this.filterByCleanTypeId = this.renderFilter('hk_ms_statehk_room_id', id, 'eq');
	} else {
		this.filterByCleanTypeId = null;
		this.statusTypeId = 0;
	}
	this.loadData();
}

async function loadBuildings(id) {
	const filterGroups = [];
	const filterBySubsidiaries = [];
	if (id) {
		this.filterBySubsidiaryId = this.renderFilter('com_subsidiary_id', id, 'eq');
		const filterBySubsidiariesId = this.renderFilter('com_subsidiaries_id', id, 'eq');
		filterGroups.push(this.filterBySubsidiaryId);
		filterBySubsidiaries.push(filterBySubsidiariesId);
	} else {
		this.filterBySubsidiaryId = null;
	}
	this.filterByRoomId = null;
	this.filterByBuildingId = null;
	this.buildingId = 0;
	this.roomId = 0;
	const request = [
		this.$http.get('building-simple-list', { params: { filter_groups: filterBySubsidiaries } }),
		this.$http.get('roomtype-simple-list', { params: { filter_groups: filterBySubsidiaries } }),
	];
	const responses = await Promise.all(request);
	this.buildings = responses[0].data;
	this.rooms = responses[1].data;
	this.loadData();
}

async function loadData() {
	const filterGroups = [];
	if (this.filterBySubsidiaryId) {
		filterGroups.push(this.filterBySubsidiaryId);
	}
	if (this.filterByBuildingId) {
		filterGroups.push(this.filterByBuildingId);
	}
	if (this.filterByRoomId) {
		filterGroups.push(this.filterByRoomId);
	}
	if (this.filterByDate) {
		filterGroups.push(this.filterByDate);
	}
	if (this.filterByTypeId) {
		filterGroups.push(this.filterByTypeId);
	}
	if (this.filterByCleanTypeId) {
		filterGroups.push(this.filterByCleanTypeId);
	}
	const response = await this.$http.get('dashboard', { params: { filter_groups: filterGroups } });
	if (this.isMounted) {
		this.statusTypes.push({ id: 0, name: 'All' });
		response.data.room_states.forEach((state) => {
			const newState = Object.assign({}, state);
			newState.isSelected = false;
			newState.isAdded = false;
			this.statusTypes.push(newState);
		});
		this.roomCleaningTypes.push({ id: 0, name: 'All' });
		response.data.type_cleaning_list.forEach((clean) => {
			this.roomCleaningTypes.push(clean);
		});
	}
	Object.keys(response.data.states).forEach((key) => {
		response.data.states[key].rooms =
		response.data.states[key].rooms.map((room) => {
			const newRoom = Object.assign({}, room);
			newRoom.isAdded = false;
			newRoom.isSelected = false;
			return newRoom;
		});
	});
	this.states = response.data.states;
	this.housemaids = response.data.housemaids;
	this.summaryStates = response.data.maid_states_quantity;
	this.summaryAlerts = response.data.maid_alerts_quantity.map((alert) => {
		const newAlert = Object.assign({}, alert);
		if (alert.code_alert === 'OP') {
			newAlert.routerName = 'lostandfound';
		} else if (alert.code_alert === 'RP') {
			newAlert.routerName = 'problem-report';
		} else {
			newAlert.routerName = 'maintenance-container';
		}
		return newAlert;
	});
	this.isMounted = false;
}

function loadRooms(id) {
	this.filterByBuildingId = this.renderFilter('hot_building_id', id, 'eq');
	this.loadData();
}

async function onDateFilter({ value, days }) {
	const newDate = new Date(this.endDate);
	if (days >= 0) {
		const dateToString = newDate.setDate(newDate.getDate() - days);
		this.startDate = new Date(dateToString).toISOString().substr(0, 10);
	}
	if (value) {
		this.value = value;
	} else {
		this.value = 0;
	}
	this.loading = true;
	this.filterByDate = this.renderFilter('date_clear', [this.startDate, this.endDate], 'bt');
	this.loadData();
	this.loading = false;
}

function roomIsSelected(room) {
	if (room.isSelected) {
		this.roomsSelected.push(room);
	} else {
		const index = this.roomsSelected.findIndex(roomSelected => roomSelected.id === room.id);
		this.roomsSelected.splice(index, 1);
	}
}

function stateToChange(room) {
	this.statusTypes = this.statusTypes.map((status) => {
		const newStatus = Object.assign({}, status);
		if (status.id === this.stateSelectedId) {
			newStatus.isSelected = false;
			newStatus.isAdded = false;
		}
		return newStatus;
	}, this);
	this.stateSelected = room;
	this.stateSelectedId = room.id;
}

function toggleIconStartDate() {
	this.onChange = !this.startDate;
}

function toggleIconEndDate() {
	this.onChange = !this.endDate;
}

function arrowIconEnd() {
	const arrow = this.onChangeEnd ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrow;
}

function arrowIconStart() {
	const arrow = this.onChange ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrow;
}

export default {
	components: {
		FiltersByTime,
		RoomStatus,
		TabsComponent,
	},
	computed: {
		arrowIconEnd,
		arrowIconStart,
	},
	created,
	data() {
		return {
			breakHref: {
				name: 'break',
			},
			buildings: [],
			buildingId: 0,
			dialog: false,
			endDate: currentDate.today,
			filterByBuildingId: null,
			filterByCleanTypeId: null,
			filterByDate: null,
			filterByRoomId: null,
			filterBySubsidiaryId: null,
			filterByTypeId: null,
			formatted: null,
			highPerformanceHref: {
				name: 'high-performance',
			},
			isMounted: false,
			loading: false,
			lowPerformanceHref: {
				name: 'low-performance',
			},
			housemaids: [],
			menu: false,
			menuEnd: false,
			onChange: false,
			onChangeEnd: false,
			roomId: 0,
			rooms: [],
			roomsSelected: [],
			roomCleaningTypes: [],
			roomTypeId: 0,
			startDate: currentDate.today,
			stateSelected: null,
			stateSelectedId: null,
			statusTypes: [],
			statusTypeId: 0,
			states: [],
			subsidiaryId: 0,
			summaryAlerts: [],
			summaryStates: [],
			tabs: [
				{
					id: 1,
					title: 'Trabajadores',
					link: '/dashboard',
				},
				{
					id: 2,
					title: 'Ventas',
					link: '/dashboard/sales',
				},
			],
			value: 0,
		};
	},
	methods: {
		cancelEdit,
		changeEndIcon,
		changeFormatDate,
		changeIcon,
		deleteRoomAdded,
		editRoomStates,
		filterById,
		filterStatusType,
		filterType,
		loadBuildings,
		loadData,
		loadRooms,
		onDateFilter,
		roomIsSelected,
		stateToChange,
		toggleIconEndDate,
		toggleIconStartDate,
	},
	mixins: mixin,
	name: 'main-dashboard',
};
</script>

<style lang="scss" scoped>

.start-date-select label {
	margin: -14px 0px 0px 25%;
}

.button-default {
	margin-bottom: 12px;
	margin-top: 0;
}

.oval-select {
	&.input-group {
		border: 2px solid map-get($colors, room-status-filter);
		border-radius: 100px;
		box-shadow: none;
		height: 23px;
		max-width: fit-content;
		min-height: 23px;
		min-width: 125px;
	}
}

.label-status {
	background-color: map-get($colors, bg-subtitle);
	flex: none;
	height: 26px;
	margin-bottom: 15px;
	padding: 0 20px 0 11px;
	width: 100%;

	h5 {
		display: inline-flex;
		font-size: map-get($sizes, twelve);
		margin: -2px 0 0 0;

		a {
			color: map-get($colors, default-label);
		}

		&:first-child {
			float: left;
		}

		&:nth-child(2) {
			float: right;
		}
	}
}

.divider-rows {
	.divider1 {
		border-right: 1px solid map-get($colors, e-bg-icon);
		padding-right: 1%;
	}

	.divider2 {
		padding-left: 1%;

		.alerts {
			border-top: 1px solid map-get($colors, e-bg-icon);
			margin-top: 2%;
		}

		&>.layout {
			&:first-child {
				height: 29px;
			}

			&:nth-child(3) h5 {
				margin-bottom: 0;
				margin-top: 16px;
			}
		}

		.b-alerts {
			border-bottom: 1px solid map-get($colors, e-bg-icon);
			padding-bottom: 4%;
			padding-left: 2%;
		}
	}
}

.summary {
	&-container {
		justify-content: center;

		p {
			font-size: 48px;
			margin: 5px;
		}

		a,
		a:hover,
		a:focus,
		a:active {
			color: map-get($colors, default-label);
			font-size: map-get($sizes, twelve);
			text-decoration: none;
		}
	}

	background-color: #ffffff;
	border: 5px solid;
	border-radius: 60px;
	height: 92px;
	margin: 0 28px 10px;
	text-align: center;
	width: 92px;
}

.oval-button {
	background-color: map-get($colors, default-dark);
	border-radius: 100px;
	color: white;
	font-family: map-get($fonts, semibold);
	font-size: map-get($sizes, twelve);
	height: 23px;
	line-height: 21px;
	min-width: 64px;

	&[disabled] {
		background-color: transparent;
		border: 2px solid map-get($colors, room-status-filter);
		color: map-get($colors, room-status-filter);
	}

	&.cancel {
		background-color: map-get($colors, calendary-red);
	}
}

.report-maid {
	border-bottom: 1px solid transparent;
	padding: 0 20px 0 10px;

	a,
	span {
		color: black;
		font-size: map-get($sizes, fourteen);
		margin: 0;
		vertical-align: middle;
	}

	&:hover {
		border-bottom: 1px solid map-get($colors, default-skyblue);
		cursor: pointer;

		a,
		span {
			font-family: map-get($fonts, medium);
			font-size: map-get($sizes, fourteen);
		}
	}
}

.realtime {
	&-content {
		background-color: white;
		margin-bottom: 28px;
		margin-left: 8px;
		padding: 14px 10px;
		width: 100%;

		.realtime-item {
			border-bottom: 1px solid map-get($colors, e-bg-icon);
			height: fit-content;
			margin-bottom: 12.5px;
			text-align: left;

			img {
				border-radius: 50px;
				height: 46px;
				width: 46px;
			}

			h5 {
				font-size: map-get($sizes, fourteen);
				line-height: 18px;
				margin-bottom: 11px;
			}

			h6 {
				font-size: map-get($sizes, twelve);
			}
		}

		.little-icon {
			align-content: center;
		}
	}

	&-blue {
		color: map-get($colors, default-skyblue);
	}

	&-gray {
		color: map-get($colors, realtime-label);
	}

	&-green {
		color: map-get($colors, default-green);
	}

	&-red {
		color: map-get($colors, default-red);
	}
}

.score {
	&-ball {
		border-radius: 100%;
		display: inline-block;
		height: 14px;
		vertical-align: middle;
		width: 14px;
	}
}

.rt-calendar {
	border-radius: 20px;
	display: inline-flex;
	height: 17px;
	margin-right: 6px;
	width: 17px;

	&.blue {
		@include default-little-icon(map-get($colors, realtime-skyblue), url(/static/img/sprites/spritesheet-icons.png), -38px -23px);
	}

	&.red {
		@include default-little-icon(map-get($colors, default-red), url(/static/img/sprites/spritesheet-icons.png), -26px -1px);
	}

	& + h6 {
		display: inline-flex;
		vertical-align: super;
	}
}

.modal-dashboard {
	.headline {
		color: map-get($colors, default-dark);
		font-family: map-get($fonts, medium);
		font-size: map-get($sizes, twenty) !important;
		padding-bottom: 0px;

		i {
			color: map-get($colors, header-dark);
			cursor: pointer;
			position: absolute;
			right: 10px;
			top: 10px;
		}
	}

	.subtitle {
		color: map-get($colors, default-dark);
		font-family: map-get($fonts, medium);
		font-size: map-get($sizes, fourteen);
		margin: 0px;
	}
}
</style>




// WEBPACK FOOTER //
// Dashboard.vue?383b001f